"use client";

import { useRef } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useGSAP } from "@gsap/react";
gsap.registerPlugin(useGSAP, ScrollTrigger);
const stats = [{
  value: 1937,
  suffix: "",
  prefix: "",
  decimals: 0,
  label: "Anos de experiência acumulada em engenharia de precisão",
  inverted: false
}, {
  value: 100,
  suffix: "%",
  prefix: "",
  decimals: 0,
  label: "Compromisso com a qualidade e inovação industrial",
  inverted: true
}, {
  value: 30,
  suffix: "+",
  prefix: "",
  decimals: 0,
  label: "Anos como representantes exclusivos da Spraying Systems",
  inverted: false
}, {
  value: 500,
  suffix: "+",
  prefix: "",
  decimals: 0,
  label: "Soluções de pulverização implementadas com sucesso",
  inverted: false
}];
function formatValue(v: number, decimals: number) {
  if (decimals === 0) return Math.round(v).toString();
  return v.toFixed(decimals);
}
export default function Metrics() {
  const container = useRef<HTMLDivElement>(null);
  useGSAP(() => {
    const el = container.current;
    if (!el) return;
    const mm = gsap.matchMedia();
    mm.add("(prefers-reduced-motion: no-preference)", () => {
      gsap.set(".intel-intro", {
        y: 16
      });
      gsap.to(".intel-intro", {
        opacity: 1,
        y: 0,
        duration: 0.7,
        stagger: 0.1,
        ease: "power3.out",
        scrollTrigger: {
          trigger: el,
          start: "top 82%",
          once: true
        }
      });
      gsap.set(".intel-cell", {
        y: 24
      });
      gsap.to(".intel-cell", {
        opacity: 1,
        y: 0,
        duration: 0.7,
        stagger: 0.12,
        ease: "power3.out",
        scrollTrigger: {
          trigger: el,
          start: "top 82%",
          once: true
        }
      });
      gsap.to(".intel-hairline", {
        scaleX: 1,
        duration: 0.5,
        stagger: 0.12,
        ease: "power2.out",
        scrollTrigger: {
          trigger: el,
          start: "top 82%",
          once: true
        }
      });
      const numerals = el.querySelectorAll<HTMLElement>(".intel-numeral");
      numerals.forEach((node, i) => {
        const target = parseFloat(node.dataset.target || "0");
        const decimals = parseInt(node.dataset.decimals || "0", 10);
        const prefix = node.dataset.prefix || "";
        const suffix = node.dataset.suffix || "";
        const obj = {
          val: 0
        };
        gsap.to(obj, {
          val: target,
          duration: 1.2,
          ease: "power3.out",
          delay: i * 0.12,
          scrollTrigger: {
            trigger: el,
            start: "top 82%",
            once: true
          },
          onUpdate: () => {
            node.textContent = `${prefix}${formatValue(obj.val, decimals)}${suffix}`;
          }
        });
      });
    });
    mm.add("(prefers-reduced-motion: reduce)", () => {
      gsap.set([".intel-intro", ".intel-cell"], {
        opacity: 1,
        y: 0
      });
      gsap.set(".intel-hairline", {
        scaleX: 1
      });
      const numerals = el.querySelectorAll<HTMLElement>(".intel-numeral");
      numerals.forEach(node => {
        const target = parseFloat(node.dataset.target || "0");
        const decimals = parseInt(node.dataset.decimals || "0", 10);
        const prefix = node.dataset.prefix || "";
        const suffix = node.dataset.suffix || "";
        node.textContent = `${prefix}${formatValue(target, decimals)}${suffix}`;
      });
    });
    const refresh = () => ScrollTrigger.refresh();
    requestAnimationFrame(refresh);
    if (document.readyState === "complete") refresh();else window.addEventListener("load", refresh, {
      once: true
    });
    document.fonts?.ready.then(refresh);
  }, {
    scope: container
  });
  return <section data-section-id="31404" id="customersuccessmetrics" data-nav="dark" className="relative overflow-hidden bg-background text-foreground" style={{
    paddingTop: "clamp(96px, 12vw, 176px)",
    paddingBottom: "clamp(96px, 12vw, 176px)"
  }}>
      {}
      <div aria-hidden="true" className="pointer-events-none absolute inset-x-0 top-1/2 h-px -translate-y-1/2" style={{
      background: "linear-gradient(90deg, transparent 0%, hsl(215 90% 45% / 0.05) 20%, hsl(215 90% 45% / 0.08) 50%, hsl(215 90% 45% / 0.05) 80%, transparent 100%)",
      filter: "blur(48px)",
      height: "180px"
    }} />

      <div ref={container} className="relative mx-auto w-full" style={{
      maxWidth: "1360px",
      paddingLeft: "clamp(20px, 4vw, 56px)",
      paddingRight: "clamp(20px, 4vw, 56px)"
    }}>
        {}
        <div className="mx-auto max-w-[720px] text-center">
          <p className="intel-intro font-default font-medium uppercase text-muted-foreground" style={{
          opacity: 0,
          letterSpacing: "0.22em",
          fontSize: "clamp(0.6875rem, 0.78vw, 0.8125rem)",
          lineHeight: 1
        }}>
            Eurocontrol em Números
          </p>
          <h2 className="intel-intro font-default font-medium text-foreground" style={{
          opacity: 0,
          marginTop: "20px",
          fontSize: "clamp(1.625rem, 2.8vw, 2.375rem)",
          letterSpacing: "-0.02em",
          lineHeight: 1.12
        }}>
            Excelência técnica e resultados comprovados.
          </h2>
          <p className="intel-intro font-default text-muted-foreground" style={{
          opacity: 0,
          marginTop: "20px",
          fontSize: "clamp(1rem, 1.05vw, 1.0625rem)",
          lineHeight: 1.6
        }}>
            Décadas de experiência ao serviço da indústria, garantindo precisão e eficiência em cada sistema de pulverização.
          </p>
        </div>

        {}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" style={{
        marginTop: "80px"
      }}>
          {stats.map((stat, i) => {
          if (stat.inverted) {
            return <div key={i} data-index={i} className="intel-cell group rounded-lg p-8 transition-transform duration-300" style={{
              opacity: 0,
              backgroundColor: "hsl(215 80% 20% / 0.05)"
            }}>
                  <div className="intel-numeral font-default font-light" data-target={stat.value} data-decimals={stat.decimals} data-prefix={stat.prefix} data-suffix={stat.suffix} style={{
                color: "hsl(215 80% 20%)",
                fontSize: "clamp(3.5rem, 8vw, 7rem)",
                letterSpacing: "-0.04em",
                lineHeight: 1
              }}>
                    0
                  </div>
                  <div className="intel-hairline origin-left" style={{
                marginTop: "16px",
                width: "48px",
                height: "1px",
                backgroundColor: "hsl(215 80% 20% / 0.25)",
                transform: "scaleX(0)",
                transition: "width 280ms cubic-bezier(0.22,0.61,0.36,1)"
              }} />
                  <p className="font-default" style={{
                marginTop: "16px",
                color: "hsl(220 22% 6%)",
                fontSize: "clamp(0.8125rem, 0.88vw, 0.9375rem)",
                letterSpacing: "0.02em",
                lineHeight: 1.45
              }}>
                    {stat.label}
                  </p>
                </div>;
          }
          return <div key={i} data-index={i} className="intel-cell group flex flex-col" style={{
            opacity: 0,
            padding: "8px 0"
          }}>
                <div className="intel-numeral font-default font-light transition-transform duration-300 group-hover:-translate-y-0.5" data-target={stat.value} data-decimals={stat.decimals} data-prefix={stat.prefix} data-suffix={stat.suffix} style={{
              color: "hsl(215 90% 45%)",
              fontSize: "clamp(3.5rem, 8vw, 7rem)",
              letterSpacing: "-0.04em",
              lineHeight: 1
            }}>
                  0
                </div>
                <div className="intel-hairline origin-left transition-all duration-300 group-hover:w-[72px]" style={{
              marginTop: "16px",
              width: "48px",
              height: "1px",
              backgroundColor: "hsl(215 90% 45% / 0.24)",
              transform: "scaleX(0)"
            }} />
                <p className="font-default text-muted-foreground" style={{
              marginTop: "16px",
              fontSize: "clamp(0.8125rem, 0.88vw, 0.9375rem)",
              letterSpacing: "0.02em",
              lineHeight: 1.45
            }}>
                  {stat.label}
                </p>
              </div>;
        })}
        </div>
      </div>
    </section>;
}